import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isPrerender } from '../utils/prerender'

function AccessibleNavigationAnnouncer() {
  const prerender = isPrerender()
  const [message, setMessage] = useState('')
  const location = useLocation()

  useEffect(() => {
    // ignore the / (and the prerender pass, which must not bake text into the HTML)
    if (!prerender && location.pathname.slice(1)) {
      // make sure navigation has occurred and screen reader is ready
      setTimeout(() => setMessage(`Navigated to ${location.pathname.slice(1)} page.`), 500)
    } else {
      setMessage('')
    }
  }, [location, prerender])

  return (
    <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </span>
  )
}

export default AccessibleNavigationAnnouncer
